import React from 'react';
import styled from 'styled-components'
import { Container, Menu } from 'semantic-ui-react'

const Styles = styled.div`
    .modern-header {
        background: var(--color-primary) !important;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
        height: 70px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3) !important;
    }

    .logo-section {
        display: flex;
        align-items: center;
        gap: 1rem;
        cursor: pointer;
        transition: opacity 0.3s ease;
    }

    .logo-section:hover {
        opacity: 0.8;
    }

    .logo-text {
        font-family: 'Syne', sans-serif;
        font-size: 1.3rem;
        font-weight: 700;
        color: var(--color-text);
        white-space: nowrap;
        margin: 0;
        padding-top: 0.2rem;
    }

    .nav-button {
        font-family: 'IBM Plex Sans', sans-serif;
        color: var(--color-text-muted) !important;
        padding: 1.5rem 1.2rem !important;
        cursor: pointer;
        transition: all 0.3s ease;
        font-weight: 500;
        letter-spacing: 0.05em;
        font-size: 0.95rem;
    }

    .nav-button:hover {
        color: var(--color-accent) !important;
        background: rgba(0, 217, 255, 0.05) !important;
    }
`

function Header() {
    const [fixed] = React.useState(true);

    return (
        <Styles>
            <Menu
                className="modern-header"
                fixed={fixed ? 'top' : null}
                size='large'
            >
                <Container>
                    <Menu.Item
                        style={{ border: 'none', padding: '0.5rem 1rem' }}
                        onClick={() => { window.location = "/" }}
                    >
                        <div className="logo-section">
                            <img
                                src="/images/yayfun-bl.svg"
                                alt="Yay Fun Logo"
                                style={{
                                    display: "block",
                                    width: "50px",
                                    height: "50px",
                                    filter: "brightness(0) invert(1)"
                                }}
                            />
                            <p className="logo-text">Yay Fun</p>
                        </div>
                    </Menu.Item>

                    <Menu.Item position='right' style={{ padding: 0, border: 'none' }}>
                        <span
                            className="nav-button"
                            onClick={() => { window.location = "/about" }}
                        >
                            ABOUT
                        </span>
                        <span
                            className="nav-button"
                            onClick={() => { window.location = "/contact" }}
                        >
                            CONTACT
                        </span>
                    </Menu.Item>
                </Container>
            </Menu>
        </Styles>
    )
}

export default Header
